import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { CurrencyProvider } from './context/CurrencyContext';

// Pages
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import AboutPage from './pages/AboutPage';
import HowItWorksPage from './pages/HowItWorksPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import CheckoutCancelPage from './pages/CheckoutCancelPage';
import OnboardingPage from './pages/OnboardingPage';
import LegacyOnboardingPage from './pages/LegacyOnboardingPage';
import PortalPage from './pages/PortalPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminPage from './pages/AdminPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CheckoutPage from './pages/CheckoutPage';
import FAQPage from './pages/FAQPage';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import ThankYou from './pages/ThankYou';
import LegacyCollection from './pages/LegacyCollection';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <CartProvider>
          <Router>
            <Routes>
              {/* Standalone landing page — no global header/footer */}
                      <Route path="/mothers-day" element={<Navigate to="/" replace />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/legacy-collection" element={<LegacyCollection />} />

              {/* Standard pages with header/footer */}
              <Route path="*" element={
                <div className="app">
                  <Header />
                  <main>
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/shop" element={<ShopPage />} />
                      <Route path="/about" element={<AboutPage />} />
                      <Route path="/how-it-works" element={<HowItWorksPage />} />
                      <Route path="/checkout" element={<CheckoutPage />} />
                      <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                      <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
                      <Route path="/onboarding" element={<OnboardingPage />} />
                      <Route path="/legacy/onboarding/:token" element={<LegacyOnboardingPage />} />
                      <Route path="/portal" element={<PortalPage />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/register" element={<RegisterPage />} />
                      <Route path="/admin" element={<AdminPage />} />
                      <Route path="/privacy" element={<PrivacyPolicyPage />} />
                      <Route path="/terms" element={<TermsPage />} />
                      <Route path="/faq" element={<FAQPage />} />
                      <Route path="/blog" element={<BlogPage />} />
                      <Route path="/blog/:slug" element={<BlogPost />} />
                      <Route path="/reset-password" element={<ResetPasswordPage />} />
                    </Routes>
                  </main>
                  <Footer />
                  <Toaster position="top-center" richColors />
                </div>
              } />
            </Routes>
          </Router>
        </CartProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
